import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

require("./user-avatar.scss");
@Component({
  standalone: false,
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent {

  @Input() url: any;
  @Input() user: any;
  @Input() color: string;
  @Input() size: 'xsmall' | 'small' | 'medium' | 'large' = 'medium';

  constructor() {
  }

}
